module.exports = __webpack_public_path__ + "img/KubeOperator-white.6858e3fd.png";